/**
 * SHEEP MADE SIMPLE
 * Spring Seasonal Definition
 * Version: 1.0.0
 */
(() => {
  "use strict";

  const SEASON = "spring";
  const TASKS = Object.freeze([
    "lambingManagement",
    "eweAndLambSupport",
    "grazingRotation",
    "springHealth",
    "lambProcedures",
    "shearingAndFlystrike"
  ]);

  function required(value) {
    return value !== undefined && value !== null && value !== "";
  }

  function validateLambing(data) {
    const errors = [];
    if (!required(data.lambingStatus)) errors.push("Choose your current lambing status.");
    if (data.lambingStatus === "currently_lambing" && !required(data.dailyChecks)) {
      errors.push("Choose how often you will complete lambing checks.");
    }
    return { valid: errors.length === 0, errors };
  }

  function validateEweSupport(data) {
    const errors = [];
    if (!required(data.eweCondition)) errors.push("Record the current condition of your ewes.");
    if (!required(data.supplementation)) errors.push("Record your current supplementation approach.");
    return { valid: errors.length === 0, errors };
  }

  function validateGrazing(data) {
    const errors = [];
    if (!required(data.currentRotation)) errors.push("Choose your current grazing rotation.");
    if (!required(data.grassStatus)) errors.push("Choose the current grass-growth state.");
    if (!Array.isArray(data.growthStrategies) || !data.growthStrategies.length) {
      errors.push("Choose at least one preferred spring strategy.");
    }
    return { valid: errors.length === 0, errors };
  }

  function validateHealth(data) {
    const errors = [];
    if (!required(data.wormRisk)) errors.push("Choose the current worm-risk state.");
    if (!required(data.feetStatus)) errors.push("Record whether feet have been checked.");
    if (!required(data.lambGrowth)) errors.push("Record the current lamb-growth state.");
    return { valid: errors.length === 0, errors };
  }

  function validateProcedures(data) {
    const errors = [];
    if (!required(data.status)) errors.push("Choose the current status of lamb procedures.");
    if (data.status === "not_required") return { valid: true, errors: [] };
    if (!Array.isArray(data.procedures) || !data.procedures.length) {
      errors.push("Choose at least one procedure.");
    }
    if (data.status === "planned") {
      if (!required(data.plannedDate)) errors.push("Add the planned date.");
      if (!Number.isFinite(data.plannedLambCount) || data.plannedLambCount < 1) {
        errors.push("Add the planned number of lambs.");
      }
    }
    if (data.status === "completed") {
      if (!required(data.completedDate)) errors.push("Add the completed date.");
      if (!Number.isFinite(data.completedLambCount) || data.completedLambCount < 1) {
        errors.push("Add the number of lambs completed.");
      }
    }
    return { valid: errors.length === 0, errors };
  }

  function validateShearing(data) {
    const errors = [];
    if (!required(data.shearingStatus)) errors.push("Choose your current shearing status.");
    if (["booked", "completed"].includes(data.shearingStatus) && !required(data.shearingDate)) {
      errors.push("Add the shearing date.");
    }
    if (!required(data.flystrikeMonitoring)) errors.push("Choose the flystrike-monitoring status.");
    return { valid: errors.length === 0, errors };
  }

  function normaliseTaskData({ taskId, data }) {
    const output = { ...data };
    if (taskId === "lambingManagement" && output.lambingStatus !== "currently_lambing") {
      output.dailyChecks = null;
    }
    if (taskId === "lambProcedures" && output.status === "not_required") {
      return {
        status: "not_required",
        plannedDate: null,
        plannedLambCount: null,
        completedDate: null,
        completedLambCount: null,
        procedures: []
      };
    }
    return output;
  }

  function registerSpringDefinition() {
    const engine = window.SMSSeasonalEngine;

    if (
      !engine ||
      typeof engine.getDefinition !== "function" ||
      typeof engine.registerSeason !== "function"
    ) {
      window.setTimeout(registerSpringDefinition, 50);
      return;
    }

    if (!engine.getDefinition(SEASON)) {
      engine.registerSeason({
        season: SEASON,
        taskOrder: TASKS,
        normaliseTaskData,
        validators: {
          lambingManagement: validateLambing,
          eweAndLambSupport: validateEweSupport,
          grazingRotation: validateGrazing,
          springHealth: validateHealth,
          lambProcedures: validateProcedures,
          shearingAndFlystrike: validateShearing
        }
      });
    }
  }

  registerSpringDefinition();
})();
